import { render, staticRenderFns } from "./RegularBuyBoxNew.vue?vue&type=template&id=f0d661fe&scoped=true"
import script from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularBuyBoxNew.vue?vue&type=style&index=0&id=f0d661fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d661fe",
  null
  
)

export default component.exports